import { Box } from "@mui/material";
import Home from "./pages/Home";

function App() {
  return (
    <Box>
      <Home />
    </Box>
  );
}

export default App;
